var _path;

import * as React from "react";

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.498 4H5.503C4.17 4 3.498 5.617 4.443 6.56L16 18.122V31c0 .49.239.948.64 1.229l5 3.499c.986.69 2.36-.01 2.36-1.23V18.122l11.56-11.56C36.5 5.619 35.833 4 34.497 4z"
  })));
}

export default SvgFilter;